import { render, staticRenderFns } from "./DashboardCellMediationAdUnits.vue?vue&type=template&id=22e7702e&scoped=true&"
import script from "./DashboardCellMediationAdUnits.vue?vue&type=script&lang=js&"
export * from "./DashboardCellMediationAdUnits.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  
}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "22e7702e",
  null
  ,true
)

export default component.exports